<template>
    <transition>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Accounts </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Fiscal Year Closing</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            <!-- <button type="button" class="btn btn-dark float-right" @click="redirectRoute('/accounting/voucher-list')">
                              <i class="mdi mdi-arrow-left-thin"></i> Back
                            </button>  -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 ">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <form @submit.prevent="submitClosingBalanceForm" enctype="multipart/form-data" id="ventry_form" class="ventry_form" v-if="!loading">
                                    <div class="col-md-12">
                                        <div class="row">
                                            
                                            <div class="form-group col-md-3">
                                                <label for="company_id">Company *</label><br>
                                                <Multiselect 
                                                    class="form-control border company_id" 
                                                    mode="single"
                                                    v-model="vform.company_id"
                                                    placeholder="Company Select"  
                                                    :searchable="true" 
                                                    :filter-results="true"
                                                    :options="company_options"
                                                    :classes="multiclasses"
                                                    :close-on-select="true" 
                                                    :min-chars="1"
                                                    :resolve-on-load="false"
                                                    @change="getFiscalYearClosingData($event)"
                                                /> 
                                                <div class="invalid-feedback" v-if="errors.company_id">
                                                    {{errors.company_id[0]}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                        
                                    <hr>

                                    <div class="entry_table" style="position: relative;">
                                        <div v-if="!ledgerLoading">
                                            <table class="table table-bordered w-100">
                                                <thead class="table-light">
                                                    <tr class="border success item-head">
                                                        <th class="text-center" style="width: 50%;">Closing Fiscal Year</th> 
                                                        <th class="text-center" style="width: 50%;">Closing To Fiscal Year</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="text-center">
                                                            <Multiselect 
                                                                class="form-control border" 
                                                                mode="single"
                                                                v-model="vform.from_fiscal_year_id"
                                                                placeholder="Select From Fiscal Year"  
                                                                :searchable="true" 
                                                                :filter-results="true"
                                                                :options="fromFiscalYearOptions"
                                                                :classes="multiclasses"
                                                                :close-on-select="true" 
                                                                :min-chars="1"
                                                                :resolve-on-load="false"
                                                            />
                                                        </td>
                                                        <td class="text-center">
                                                            <Multiselect 
                                                                class="form-control border" 
                                                                mode="single"
                                                                v-model="vform.to_fiscal_year_id"
                                                                placeholder="Select To Fiscal Year"  
                                                                :searchable="true" 
                                                                :filter-results="true"
                                                                :options="toFiscalYearOptions"
                                                                :classes="multiclasses"
                                                                :close-on-select="true" 
                                                                :min-chars="1"
                                                                :resolve-on-load="false"
                                                            />
                                                        </td>
                                                    </tr>
                                                </tbody>

                                                <tbody>
                                                    <tr>
                                                        <td colspan="2"></td>
                                                    </tr>
                                                </tbody>
                                                <tbody>
                                                    <tr>
                                                        <th>
                                                            #Balance Sheet Items
                                                        </th>
                                                        <th>
                                                            #Balance Sheet Items
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <table class="table w-100">
                                                                <thead class="table-light">
                                                                    <tr class="border success item-head">
                                                                        <th style="width: 20%;">Code</th> 
                                                                        <th style="width: 50%;">Ledger</th>
                                                                        <th style="width: 30%;">Balance</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item, index) in balance_sheet_ledgers" :key="index">
                                                                        <td>{{ item.ledger_code }}</td>
                                                                        <td>{{ item.ledger_name }}</td>
                                                                        <td style="text-align: right;">
                                                                            <input type="number" step="any" class="form-control" v-model="item.balance" :disabled="true" style="text-align: right;" />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                                <tfoot>
                                                                    <tr>
                                                                        <th colspan="2" style="text-align: right;">Balance: </th>
                                                                        <th style="text-align: right;">
                                                                            {{ totalBalanceSheetBalance }}
                                                                        </th>
                                                                    </tr>   
                                                                </tfoot>
                                                            </table>
                                                        </td>
                                                        <td>
                                                            <table class="table w-100">
                                                                <thead class="table-light">
                                                                    <tr class="border success item-head">
                                                                        <th class="text-center" style="width: 20%;">Code</th> 
                                                                        <th class="text-center" style="width: 50%;">Ledger</th>
                                                                        <th class="text-center" style="width: 30%;">Balance</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(citem, index) in closing_balance_sheet_ledgers" :key="index">
                                                                        <td>{{ citem.ledger_code }}</td>
                                                                        <td>{{ citem.ledger_name }}</td>
                                                                        <td style="text-align: right;">
                                                                            <input type="number" step="any" class="form-control" v-model="citem.balance" style="text-align: right;" />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                                <tfoot>
                                                                    <tr>
                                                                        <th colspan="2" style="text-align: right;">Balance: </th>
                                                                        <th style="text-align: right;"> {{ totalClosingBalanceSheetBalance }}</th>
                                                                    </tr>   
                                                                </tfoot>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>

                                                <tbody>
                                                    <tr>
                                                        <td colspan="2"></td>
                                                    </tr>
                                                </tbody>
                                                <tbody>
                                                    <tr>
                                                        <th colspan="2">
                                                            #Profit/Loss Items
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2"> 
                                                            <table class="table w-100">
                                                                <thead class="table-light">
                                                                    <tr class="border success item-head">
                                                                        <th style="width: 20%;">Code</th> 
                                                                        <th style="width: 50%;">Ledger</th>
                                                                        <th style="width: 30%;">Balance</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item, index) in profit_loss_ledgers" :key="index">
                                                                        <td>{{ item.ledger_code }}</td>
                                                                        <td>{{ item.ledger_name }}</td>
                                                                        <td style="text-align: right;">{{ item.balance }}</td>
                                                                    </tr>
                                                                </tbody>

                                                                <tbody>
                                                                    <tr>
                                                                        <th colspan="2" style="text-align: right;">Balance: </th>
                                                                        <th style="text-align: right;">{{  totalProfitLossBalance }}</th>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div class="tab-pane show active" v-if="ledgerLoading">
                                            <div class="row"> 
                                                <div class="col-md-5">  
                                                </div>
                                                <div class=" col-md-2"> 
                                                    <img src="../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                                </div>
                                                <div class="col-md-5">  
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <button type="submit" class="btn btn-primary float-right" :disabled="disabled"> 
                                            <span v-show="isSubmit">
                                                <i class="fas fa-spinner fa-spin" ></i>
                                            </span>
                                            <i class="mdi mdi-content-save-all"></i> Save
                                        </button>
                                        <button type="button" class="btn btn-danger float-right" style="margin-right: 5px;"> <i class="mdi mdi-close"></i> Cancel</button>
                                    </div>
                                </form>                        
                            </div>
                        </div>

                        <div class="tab-pane show active" v-if="loading">
                            <div class="row"> 
                                <div class="col-md-5">  
                                </div>
                                <div class=" col-md-2"> 
                                    <img src="../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                </div>
                                <div class="col-md-5">  
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>     
            
        </div>
    </transition>
</template>
<script>
import Modal from "./../helper/Modal";
import { ref, onMounted } from "vue";
import axios from 'axios';
import Form from 'vform';
import NumberToWord from './../page/NumberToWord.vue';

export default {
    name: 'PosLeftbar',
    components: {
        Modal,
        NumberToWord
    },
    data() {
        return {
            loading: true,
            ledgerLoading: false,
            isSubmit: false,
            disabled: false,
            showModal: false,
            modalActive:false,
            errors: {},
            companies: [],
            company_options: [],
            fromFiscalYearOptions: [],
            toFiscalYearOptions: [],
            active_fiscal_year: [],
            to_fiscal_years: [],
            balance_sheet_ledgers: [],
            closing_balance_sheet_ledgers: [],
            profit_loss_ledgers: [],
            debit_transactions: [],
            credit_transactions: [],
            carry_forwarded: [],

            renderOptionComponent: true,
            valueConsistsOf: 'BRANCH_PRIORITY',
            normalizer(node) {
                return {
                    id: node.id +'___'+node.code,
                    label: '['+ node.code +'] '+ node.name,
                    // isDisabled: disable_item,
                    children: node.children,
                    // children_data
                }
            },

            normalizerCostCenter(node) {
                return {
                    id: node.id +'___'+node.code,
                    label: node.name,
                    children: node.children,
                }
            },
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },
            vform: new Form({
                company_id: '',
                from_fiscal_year_id: '',
                to_fiscal_year_id: '',
                // vdate: new Date().toISOString().slice(0,10),
            }),
        };
    },
    created() {
        this.fetchCompany();
    },
    methods: {
        redirectRoute: function(route_link) {
            this.$router.push(route_link);
        },

        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
            });
        },

        fetchCompany() { 
            axios.get(this.apiUrl+'/companies', this.headerjson)
            .then((res) => {
                this.companies = res.data.data;
                // this.company_options = [{label: "Select Company", value: ""}];
                res.data.data.map((item) => {
                    this.company_options.push({label: item.name, value: item.id});
                });
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            })
            .finally(() => {
                this.loading = false;
            });
        },

        // Cost Center Data
        getFiscalYearClosingData(company_id) {
            this.vform.company_id = company_id;
            if(this.vform.company_id == '' || this.vform.company_id == null) {
                return false;
            }else {
                this.loading = true;
                let filters = new Form({
                    company_id: this.vform.company_id,
                });

                axios.post(this.apiUrl+'/accounts/fiscal-year-closing-create', filters, this.headerjson)
                .then((resp) => {
                    console.log("getFiscalYearClosingData==", resp.data.data.toFiscalYears);
                    this.active_fiscal_year = resp.data.data.activeFiscalYear;
                    this.to_fiscal_years = resp.data.data.toFiscalYears;
                    this.balance_sheet_ledgers = resp.data.data.balanceSheetLedgers;
                    this.closing_balance_sheet_ledgers = resp.data.data.closingBalanceSheetLedgers;
                    this.profit_loss_ledgers = resp.data.data.profitLossLedgers;
                    this.debit_transactions = resp.data.data.debitTransactions;
                    this.credit_transactions = resp.data.data.creditTransactions;
                    this.carry_forwarded = resp.data.data.carryForwarded;

                    this.fromFiscalYearOptions =  [{label: resp.data.data.activeFiscalYear.label+' ['+resp.data.data.activeFiscalYear.start_date+' to '+resp.data.data.activeFiscalYear.end_date+']', value: resp.data.data.activeFiscalYear.id}];
                    this.vform.from_fiscal_year_id = resp.data.data.activeFiscalYear.id;
                    this.toFiscalYearOptions = resp.data.data.toFiscalYears.map((item) => {
                        return {label: item.label+' ['+item.start_date+' to '+item.end_date+']', value: item.id};
                    });
                    this.vform.to_fiscal_year_id = resp.data.data.toFiscalYears[0].id;
                })
                .catch((err) => {
                    this.$toast.error(err.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            }
        },

        fetchFiscalYear() {
            axios.get(this.apiUrl+'/fiscal_years', this.headerjson) 
            .then((resp) => {
                this.fiscal_years = resp.data.data;
                this.company_fiscal_years = resp.data.data;

                let active_fiscal_year = resp.data.data.filter((item) => item.status == 1);
                if(active_fiscal_year.length > 0) {
                    this.vform.fiscalyear_id = active_fiscal_year[0].id;
                    this.vform.vdate = active_fiscal_year[0].start_date;
                    this.active_min_date = active_fiscal_year[0].start_date;
                    this.active_max_date = active_fiscal_year[0].end_date;
                }else{
                    
                    this.vform.fiscalyear_id = '';
                    this.vform.vdate = '';
                    this.active_min_date = '';
                    this.active_max_date = '';
                }
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            }).finally(() => {
                this.loading = false;
            });
        },

        getFiscalYear: function(value) {
            let selectVal = value;
            this.vform.company_id = selectVal;
            if(this.vform.company_id == '' || this.vform.company_id == null) {
                return false;
            }else {
                this.company_fiscal_years = this.fiscal_years.filter((item) => item.company_id == this.vform.company_id);
                let active_fiscal_year = this.company_fiscal_years.filter((item) => item.status == 1);
                if(active_fiscal_year.length > 0) {
                    this.vform.fiscalyear_id = active_fiscal_year[0].id;
                    this.vform.vdate = active_fiscal_year[0].start_date;
                    this.active_min_date = active_fiscal_year[0].start_date;
                    this.active_max_date = active_fiscal_year[0].end_date;
                }else{
                    
                    this.vform.fiscalyear_id = '';
                    this.vform.vdate = '';
                    this.active_min_date = '';
                    this.active_max_date = '';
                }
            }
        },

        fetchCostCenter() {
            axios.get(this.apiUrl+'/cost_centers', this.headerjson)
            .then((resp) => {
                this.cost_centers = resp.data.data.cost_centers;
                this.costCenterOptions = resp.data.data.cost_and_profit_center_options;
            })
            .catch((err) => {
                console.log(err);
            })
        },

        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        }, 

        // inputChange: function(block_index, index) {
        //     var debit_amount = this.vform.transaction_blocks[block_index].account_items.reduce(function(total, item){
        //         var debit_amount = (item.debit != '') ? item.debit : 0;
        //         return parseFloat(total + parseFloat(debit_amount)); 
        //     },0);

        //     var credit_amount = this.vform.transaction_blocks[block_index].account_items.reduce(function(total, item){
        //         var credit_amount = (item.credit != '') ? item.credit : 0;
        //         return parseFloat(total + parseFloat(credit_amount)); 
        //     },0);

        //     this.vform.transaction_blocks[block_index].total_debit_amount = debit_amount;
        //     this.vform.transaction_blocks[block_index].total_credit_amount = credit_amount;
        // },

        submitClosingBalanceForm: function(event) {
            this.isSubmit = true; 
            this.disabled = true;

            var formData = new FormData();
            formData.append("company_id", this.vform.company_id ?? '');
            formData.append("from_fiscal_year_id", this.vform.from_fiscal_year_id ?? '');
            formData.append("to_fiscal_year_id", this.vform.to_fiscal_year_id ?? '');
            formData.append("closing_balance_sheet_ledgers", JSON.stringify(this.closing_balance_sheet_ledgers));
            formData.append("profit_loss_balance", this.totalProfitLossBalance);

            axios.post(this.apiUrl+'/accounts/fiscal-year-closing-store', formData, this.headers)
            .then((resp) => {
                this.isSubmit = false;
                this.disabled = false;
                if(resp.status == 200){
                    this.$toast.success(resp.data.message); 
                    this.$router.push({ name: 'fiscal-year-closing-list'});
                    // setTimeout(() => {
                    //     window.location.reload(true);
                    // }, 3000);
                }else{
                    this.$toast.error(resp.data.message);
                }
            })
            .catch((err) => {
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            })
            .finally(() => {
                this.isSubmit = false; 
                this.disabled = false;
            });
            
        },

        // For Print
        printContent(document_id) {
            const options = {
                name: '_blank',
                specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
                styles: [
                    // 'https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css',
                    '/assets/css/app.min.css',
                    this.baseUrlPrintCSS+'/assets/css/bootstrap.min.css',
                    this.baseUrlPrintCSS+'/assets/css/print.css'
                ],
            };
            this.$htmlToPaper(document_id, options);
        },

    },

    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {
        totalBalanceSheetBalance: function(){ 
            return this.balance_sheet_ledgers.reduce(function(total, item){
                var balance = (item.balance != '') ? item.balance : 0;
                return parseFloat(total + parseFloat(balance)); 
            },0);
        },

        totalClosingBalanceSheetBalance: function(){ 
            return this.closing_balance_sheet_ledgers.reduce(function(total, item){
                var balance = (item.balance != '') ? item.balance : 0;
                return parseFloat(total + parseFloat(balance)); 
            },0);
        },

        totalProfitLossBalance: function(){ 
            return this.profit_loss_ledgers.reduce(function(total, item){
                var balance = (item.balance != '') ? item.balance : 0;
                return parseFloat(total + parseFloat(balance)); 
            },0);
        },
        
        totalDebitAmount: function(){ 
            return this.debit_transactions.reduce(function(total, item){
                var debit_amount = (item.debit_amount != '') ? item.debit_amount : 0;
                return parseFloat(total + parseFloat(debit_amount)); 
            },0);
        }, 
        totalCreditAmount: function() {
            return this.credit_transactions.reduce(function(total, item) {
                var credit_amount = (item.credit_amount != '') ? item.credit_amount : 0;
                return parseFloat(total + parseFloat(credit_amount)); 
            },0);
        },
    }
}
</script>
<style scoped>

.vue-treeselect__menu {
    z-index: 9999;
    display: none;
}
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 90%;
    display: block;
    margin: 0 auto;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}

.actions a{
    margin-right: 5px;
}
</style>